<div fxLayout="row" fxLayoutAlign="end center">
    <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
</div>
<div fxLayout="column" fxLayoutAlign="start start">
    <label mat-dialog-title class="otpHeader">Guidelines for Display Names</label>

</div>

<div mat-dialog-content  fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px"
    class="guidelines-header">
    <div fxLayout="column" fxLayoutAlign="start start">
        <div >
            <label class="guidelines-sub-header">Display Names</label>
        </div>
        <div>
            <label class="guidelines-msg"> When you add a new phone number to your SwiftChat Business Account (WABA) in
                the Facebook Business Manager, you assign it a display name. The display name is used to create a
                certificate, which the SwiftChat Business API requires to work.</label>
        </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start start">
        <div>
            <label class="guidelines-sub-header">Set Display Name</label>
        </div>
        <div>
            <label class="guidelines-msg">You assign a display name to your phone number and submit it for review by the
                SwiftChat team from your Business Manager. See Set up a Phone Number for your SwiftChat Business Account
                for more information about setting up a phone number and display name.</label>
        </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start start">
        <div>
            <label class="guidelines-sub-header">Display Name Guidelines</label>
        </div>
        <div>
            <label class="guidelines-msg">All display names should have a relationship with your business and submit
                it for review by the SwiftChat team from your Business Manager.
            </label>
        </div>
    </div>

</div>
    
  
    